Librarian.Modules.Popular = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["prepCartItem"],

    options: {
        classPrefix: "modules-popular-",
        contentType: Librarian.contentType.slide,
        detailed: false,
        showGetLink: false,
        showShareLink: true,
        startDate: null,
        endDate: null,
        orderBy: null,
        spinner: false
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    reload: function() {
        // Make sure we don't destroy the wrapper,
        // but save the set value so we can reset it after
        var destroyWrapperVal = this.destroyWrapper;
        this.destroyWrapper = false;

        this.destroy();
        this.load();

        // Reset the saved value
        this.destroyWrapper = destroyWrapperVal;
    },

    load: function() {
        var self = this;

        if (!this.wrapperEl)
            return;

        this.parent();
        if (this.options.spinner) {
            var loadingImage = new Element("div",
            {
                "class": "popularLoadingSpinner"
            }).inject(this.wrapperEl);
        }

        if (this.request) {
            this.request.cancel();
            this.request = null;
        }

        var onDataLoaded = function(json) {
            var self = this;

            // remove loading image
            if (loadingImage) {
                this.wrapperEl.getElements(".popularLoadingSpinner").destroy();
            }

            if (!json || !json.data || !json.data[0])
                return;

            var listEl = new Element("ul", {
                "class": "content-list"
            }).injectInside(this.containerEl);

            var slides = json.data || [];
            if (slides.length == 0)
                return;

            // Add a row for each item in the list which links back to the item
            slides.forEach(function(item) {
                var data = Object.toLowerKeys(item);

                var listItemEl = new Element("li", {
                    "class": "content-item"
                }).injectInside(listEl);

                var nameWrapperEl = new Element('div', {
                    "class": "content-name-wrapper"
                }).injectInside(listItemEl);

                var iconEl = new Element("img", {
                    "class": "content-icon",
                    "src": Librarian.Utils.getContentTypeIcon(item)
                }).injectInside(nameWrapperEl);

                var linkEl = new Element('a', {
                    "class": "content-name",
                    "text": item.name || item.filename,
                    "title": item.name || item.filename
                }).injectInside(nameWrapperEl);

                linkEl.data = data;
                linkEl.addOnClick(function() {
                    Librarian.PreviewWindow.openPreviewWindow(this.data);
                });

                if (self.options.detailed) {
                    var bookmarkEl = new Element("div", {
                        "class": "content-bookmark"
                    }).injectInside(listItemEl);

                    Librarian.Bookmarks.getBookmarkId(item.contentid, item.contenttype, function(bookmarkId) {
                        if (bookmarkId > 0) {
                            bookmarkEl.addClass("bookmarked");
                            bookmarkEl.bookmarkId = bookmarkId;
                        }
                    });  

                    var threeDotEl = new Element("div", {
                        "class": "content-menu-icon"
                    }).injectInside(listItemEl);

                    var menuEl = new Element("div", {
                        "class": "content-menu-wrapper"
                    }).injectInside(listItemEl);

                    var downloadEl = new Element("div", {
                        "text": "Download"
                    }).injectInside(menuEl);

                    var cartEl = new Element("div", {
                        "text": "Add File"
                    }).injectInside(menuEl);

                    if (self.options.showShareLink) {
                        var shareEl = new Element("div", {
                            "text": "Share"
                        }).injectInside(menuEl);
                    }

                    var viewEl = new Element("div", {
                        "text": "View in Library"
                    }).injectInside(menuEl);

                    if (self.options.showGetLink) {
                        var getLinkEl = new Element("div", {
                            "text": "Get Link"
                        }).injectInside(menuEl);

                        getLinkEl.addOnClick(function () {
                            Librarian.Utils.getLink(data);
                        });
                    }

                    menuEl.hide();

                    threeDotEl.addEvent('mouseenter', function() {
                        menuEl.show();
                        menuEl.removeClass("open-above");

                        var menuRect = menuEl.getBoundingClientRect();
                        var contRect = self.containerEl.getBoundingClientRect();
                        var openAbove = menuRect.bottom > contRect.bottom;

                        menuEl.toggleClass("open-above", openAbove);

                        menuRect = menuEl.getBoundingClientRect();
                        var openLeft = menuRect.top < contRect.top;

                        menuEl.toggleClass("open-left", (openAbove && openLeft));

                        threeDotEl.addClass("active");
                    });

                    menuEl.addEvent('mouseenter', function() {
                        menuEl.show();
                        threeDotEl.addClass("active");
                    });

                    threeDotEl.addEvent('mouseleave', function() {
                        menuEl.hide();
                        threeDotEl.removeClass("active");
                    });

                    menuEl.addEvent('mouseleave', function() {
                        menuEl.hide();
                        threeDotEl.removeClass("active");
                    });

                    downloadEl.addOnClick(function () {
                        Library.downloadData(data);
                    });

                    cartEl.addOnClick(function () {
                   // Can't add to the cart if we don't have a cart
                        if (!Librarian.userCart)
                            return;

                        var item = self.prepCartItem(data, 1),
                            onComplete = function(success, notifyType) {
                                Librarian.Utils.showCartNotification(item, notifyType, success);

                                // Update the checkboxes on the main page
                                Librarian.Utils.updateAllCheckboxes();

                                Librarian.Cart.onChange();

                                // If we're in the cart and we just removed ourselves,
                                // close the window to prevent switching errors.
                                if (success && (notifyType == Librarian.cartNotificationTypes.removed) && this.isInCart)
                                    this.close();
                            }.bind(this);

                        // If it's already in the cart, prompt the user to remove it
                        if (Librarian.userCart.isInCart(item, true)) {
                            Librarian.userCart.removeFromCart(item, null, null, null, null, function() {
                                onComplete(!Librarian.userCart.isInCart(item), Librarian.cartNotificationTypes.removed);
                            });
                        }
                            // Otherwise, add it
                        else
                            onComplete(Librarian.userCart.addToCart(item), Librarian.cartNotificationTypes.added);
                    });

                    if (shareEl) {
                        shareEl.addOnClick(function () {
                            var eventType = Librarian.eventType.oneOff;
                            this.sendWindow = new Librarian.EventSendWindow({
                                onCloseComplete: function () {
                                    this.sendFileWindow = null;
                                }.bind(this),
                                eventType: eventType
                            }, data);
                            this.sendWindow.show();
                        });
                    }

                    viewEl.addOnClick(function () {
                        var tree = Library.getTreeByType(Librarian.catType.file, null, data.prestype);
                        Librarian.Utils.getPath(data, function(path) {
                            if (path != null)
                                Library.loadLibraryTab();
                                Librarian.Utils.selectTreeNodeByPath(tree, path);
                        });
                    });

                    new Element('span', {
                        "class": "content-field",
                        "text": "Last Modifed: " + Librarian.Utils.getDateValue(item.lastmoddate, "%x %X"),
                    }).injectInside(listItemEl);

                    new Element('span', {
                        "class": "content-field",
                        "text": "Author: " + (item.extrafields.Author || ""),
                    }).injectInside(listItemEl);

                    bookmarkEl.addOnClick(function () {
                        var self = this;
                        if (this.hasClass("bookmarked")) {
                            Librarian.Bookmarks.deleteBookmark(this.bookmarkId, item.contentid, item.contenttype, function() {
                                self.removeClass("bookmarked");
                            }.bind(this));

                        } else {
                            Librarian.Bookmarks.addBookmark(item.contentid, item.contenttype, function(bookmarkId) {
                                self.addClass("bookmarked");
                                this.bookmarkId = bookmarkId;
                            }.bind(this));
                        }
                    });
                } 
            });
        }.bind(this);
        this.request = Librarian.Utils.getPopular(20, this.options.contentType, onDataLoaded, null, null, true, this.options.customSendData);
    },

    prepCartItem: function(data, type) {
        if (!Librarian.Cart)
            return data;

        var item = new Librarian.Cart.Item(data);
        if ((type == Librarian.Utils.getItemTypeString(this.options.data)) && (this.options.data.slidenumber < 1))
            item.slidenumber = 1;
            // Files
        else if (type == Librarian.Lang.getString("item")) {
            if (this.options.data.slidenumber != 0)
                item.slidenumber = 0;
            item.itemnumber = undefined;
            if (this.options.data.slideid != 0)
                item.slideid = 0;
            // Restore the parent extra fields if we're adding this as an item
            if (this.options.parentData && this.options.parentData.extrafields)
                item.extrafields = this.options.parentData.extrafields;
        }
            // Slides/Pages
            // If there is parent data and they have extra fields, save the extrafields as parents fields
        else if (this.options.parentData && this.options.parentData.extrafields)
            item.parentfields = this.options.parentData.extrafields;

        // Reset the add type for this item so the cart can process it correctly
        item.addType = null;

        return item;
    }
});